// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editor-content[data-v-7b9614e0] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
